import {connect} from "react-redux";
import SiteListList from "./List";
import {bindActionCreators} from "redux";
import {siteVisitList} from "../../../../service/Valet/action";
import {ratingSave} from "../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    siteVisitListDetails:state.Valet.siteVisitList,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            siteVisitList,
            ratingSave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SiteListList);
